import { LazyLoad } from './lazy-load'

class LoadMore {
  constructor(el) {
    this.loadMore = el
    this.loadNextPage = this.loadNextPage.bind(this)

    if (this.loadMore) {
      this.init()
    }
  }

  async loadNextPage() {
    // Process Page Args
    const { api } = window.sapiens
    const { args } = this.loadMore.dataset
    const data = JSON.parse(args)

    // Load HTML from API
    const html = await fetch(`${api}/posts/get-page`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(res => res.text())
      .catch(error => ({ message: error }))

    if (html.error) {
      return
    }

    // Insert HTML
    const parent = this.loadMore.parentElement
    parent.insertAdjacentHTML('beforeend', html)

    // Reset Load More Button
    this.loadMore.remove()
    this.loadMore = null

    // Run LazyLoad in new Page
    const images = parent.querySelectorAll('.lazy-image:not([loaded])')
    if (images.length) {
      images.forEach(image => {
        // eslint-disable-next-line no-new
        new LazyLoad(image)
      })
    }

    // Set to Load the Next Page
    this.loadMore = parent.querySelector('.load-more')
    if (this.loadMore) {
      this.loadMore.addEventListener('click', this.loadNextPage)
    }
  }

  init() {
    this.loadMore.addEventListener('click', this.loadNextPage)
  }
}

const loadMoreInit = {
  init() {
    const elements = document.querySelectorAll('.load-more')
    Array.from(elements).map(element => new LoadMore(element))
  },
}

export default loadMoreInit
